import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type StaffMemberCreationFailedAction = {
	type: 'STAFF_MEMBER_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): StaffMemberCreationFailedAction => ({
	type: 'STAFF_MEMBER_CREATION_FAILED',
	payload,
});
